const utils = {
    timestampToTime(timestamp) {
        var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
        var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
        var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        return Y + M + D + h + m + s;
    },
    // 判断是不是pc
    isPc() {
        // var userAgentInfo = navigator.userAgent;
        // var Agents = ["Android", "iPhone",
        //     "SymbianOS", "Windows Phone",
        //     "iPad", "iPod"];
        // var flag = true;
        // for (var v = 0; v < Agents.length; v++) {
        //     if (userAgentInfo.indexOf(Agents[v]) > 0) {
        //         flag = false;
        //         break;
        //     }
        // }
        var flag = document.body.clientWidth > 900 ? true : false
        return flag;
    },
    // canvas多行处理
    dealWords(options) {
        // options.ctx.setFontSize(options.fontSize);//设置字体大小
        var allRow = Math.ceil(options.ctx.measureText(options.word).width / options.maxWidth);//实际总共能分多少行
        var count = allRow >= options.maxLine ? options.maxLine : allRow;//实际能分多少行与设置的最大显示行数比，谁小就用谁做循环次数
        var endPos = 0;//当前字符串的截断点
        for (var j = 0; j < count; j++) {
            var nowStr = options.word.slice(endPos);//当前剩余的字符串
            var rowWid = 0;//每一行当前宽度
            if (options.ctx.measureText(nowStr).width > options.maxWidth) {//如果当前的字符串宽度大于最大宽度，然后开始截取
                for (var m = 0; m < nowStr.length; m++) {
                    rowWid += options.ctx.measureText(nowStr[m]).width;//当前字符串总宽度
                    if (rowWid > options.maxWidth) {
                        if (j === options.maxLine - 1) { //如果是最后一行
                            options.ctx.fillText(nowStr.slice(0, m - 1) + '...', options.x, options.y + (j + 1) * options.lineheight);  //(j+1)*18这是每一行的高度
                        } else {
                            options.ctx.fillText(nowStr.slice(0, m), options.x, options.y + (j + 1) * options.lineheight);
                        }
                        endPos += m;//下次截断点
                        break;
                    }
                }
            } else {//如果当前的字符串宽度小于最大宽度就直接输出
                options.ctx.fillText(nowStr.slice(0), options.x, options.y + (j + 1) * options.lineheight);
            }
        }
    },
    // canvas转图片
    convertCanvasToImage(canvas) {
        var image = new Image();
        image.setAttribute('crossOrigin', 'Anonymous');
        image.src = canvas.toDataURL("image/png");
        return image;
    },
    // 图片转为base64本地图片
    getURLBase64(url) {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest()
            xhr.open('get', url, true)
            xhr.responseType = 'blob'
            xhr.onload = function () {
                if (this.status === 200) {
                    var blob = this.response
                    var fileReader = new FileReader()
                    fileReader.onloadend = function (e) {
                        var result = e.target.result
                        resolve(result)
                    }
                    fileReader.readAsDataURL(blob)
                }
            }
            xhr.onerror = function () {
                reject()
            }
            xhr.send()
        })
    },
    // 获取屏幕dpr  设备像素比
    getPixelRatio(context) {
        var backingStore = context.backingStorePixelRatio ||
            context.webkitBackingStorePixelRatio ||
            context.mozBackingStorePixelRatio ||
            context.msBackingStorePixelRatio ||
            context.oBackingStorePixelRatio ||
            context.backingStorePixelRatio || 1;
        return (window.devicePixelRatio || 1) / backingStore;
    },
    /**
       * 根据属性值获取在数组中的index
       */
    getIndexByProprety(arr, val, proprety) {
        var index = -1;
        arr.forEach((v, i, a) => {
            if (v[proprety] == val) {
                index = i;
            }
        });
        return index;
    },

    /**
     * 根据属性值获取数组中的某项
     */
    getObjByProprety(arr, val, proprety) {
        var obj = {};
        arr.forEach((v, i, a) => {
            if (v[proprety] === val) {
                obj = v;
            }
        });
        return obj;
    },
    // 防抖
    debounce(fn, delay=300) {
        let timer = null //借助闭包
        return function () {
            if (timer) {
                clearTimeout(timer)
            }
            timer = setTimeout(fn, delay) // 简化写法
        }
    },
    // 节流
    throttle(fn, delay=300) {
        let valid = true
        return function () {
            if (!valid) {
                //休息时间 暂不接客
                return false
            }
            // 工作时间，执行函数并且在间隔期内把状态位设为无效
            valid = false
            setTimeout(() => {
                fn()
                valid = true;
            }, delay)
        }
    },
    // 压缩图片
    compressImg(file) {
        var src;
        var files;
        var fileSize = parseFloat(parseInt(file['size']) / 1024 / 1024).toFixed(2);
        var read = new FileReader();
        read.readAsDataURL(file);
        return new Promise(function (resolve, reject) {
            read.onload = function (e) {
                var img = new Image();
                img.src = e.target.result;
                img.onload = function () {
                    //默认按比例压缩
                    var w = this.width,
                        h = this.height;
                    //生成canvas
                    var canvas = document.createElement('canvas');
                    var ctx = canvas.getContext('2d');
                    var base64;
                    // 创建属性节点
                    canvas.setAttribute("width", w);
                    canvas.setAttribute("height", h);
                    ctx.drawImage(this, 0, 0, w, h);
                    if (fileSize < 1) {
                        //如果图片小于一兆 那么不执行压缩操作
                        base64 = canvas.toDataURL(file['type'], 1);
                    } else if (fileSize > 1 && fileSize < 2) {
                        //如果图片大于1M并且小于2M 那么压缩0.5
                        base64 = canvas.toDataURL(file['type'], 0.5);
                    } else {
                        //如果图片超过2m 那么压缩0.2
                        base64 = canvas.toDataURL(file['type'], 0.2);
                    }
                    // 回调函数返回file的值（将base64编码转成file）
                    // console.log('base64',base64)
                    files = utils.dataURLtoFile(base64); //如果后台接收类型为base64的话这一步可以省略
                    resolve(files)
                };
            };
        })
    },
    //   base64转码（压缩完成后的图片为base64编码，这个方法可以将base64编码转回file文件）
    dataURLtoFile(dataurl, filename = 'file') {
        let arr = dataurl.split(',')
        let mime = arr[0].match(/:(.*?);/)[1]
        let suffix = mime.split('/')[1]
        let bstr = atob(arr[1])
        let n = bstr.length
        let u8arr = new Uint8Array(n)
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], `${filename}.${suffix}`, {
            type: mime
        })
    },
    // el-input 文本框校验字数，英文单词算一个字
    checkWordsLength(rule, value, callback) {
        setTimeout(() => {
            const length = value.replace(/[a-z0-9]+/ig, '$').replace(/ /g, '').length;
            if (length > 30) {
                callback(new Error('输入内容不能超过30字'));
            } else {
                callback();
            }
        }, 300);
    },
    // 设置cookie
    setCookie(name, value, Days = 7) {
        var exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);

        var domain = window.location.host;
        var domains = domain.split('.');
        if (domains.length === 3) {
            domains = domains.slice(1, 3);
            domain = '.' + domains.join('.');
            document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + exp.toGMTString() + ";path=/;domain=" + domain;
        } else {
            domain = domain;
            console.log('set cookie', name + "=" + encodeURIComponent(value) + ";expires=" + exp.toGMTString() + ";path=/;")
            document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + exp.toGMTString() + ";path=/;";
        }
    },

    // 获取cookie
    // 注解：1、例如name=jack;password=123
    //       2、获取值：var pwd = getCookie(password);//pwd值为123
    getCookie(name) {
        var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg))
            return decodeURIComponent(arr[2]);
        else
            return null;
    },
    // 删除cookie
    delCookie(name) {
        console.log('删除cookie前，获取cookie值：', name + '--' + this.getCookie(name))
        var domain = window.location.host;
        var domains = domain.split('.');
        if (domains.length === 3) {
            domains = domains.slice(1, 3);
            domain = '.' + domains.join('.');
            console.log('cookie', name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=' + domain)
            document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=' + domain;
        } else {
            domain = domain;
            document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;'
            // console.log('set cookie', name + "=" + encodeURIComponent(value) + ";expires=" + exp.toGMTString() + ";path=/;")
        }
        console.log('domain',domain)
        console.log('删除cookie后，获取cookie值：', name + '--' + this.getCookie(name));
    }
}
export default utils
